import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-feature-button',{staticClass:"text-capitalize",attrs:{"width":"150","large":"","color":"cyan","dark":"","to":"/about/privacy"},scopedSlots:_vm._u([{key:"text",fn:function(){return [_vm._v("Privacy")]},proxy:true},{key:"suffix",fn:function(){return [_c(VIcon,[_vm._v(" mdi-shield-account ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }